import { useSentry } from '../composables/sentry'
import { facetKeysBaseModel } from '../constants/productFacetsBaseModel'
import { tsClient } from './TypesenseService'

const { handleError } = useSentry()

const BaseModelsService = {
  // Get Base Models from Typesense
  getTypesenseResults: async (payload: any = {}) => {
    const {
      exactMatch = false,
      fields = ['model', 'category', 'category_2', 'gauge_connections'],
      filterString = '',
      page = 1,
      query = ''
    } = payload
    try {
      const activeOnly = 'active_dascosales_web:=true'
      const queryFields = fields.join(',')
      const searchParameters: any = {
        facet_by: facetKeysBaseModel,
        filter_by: `${activeOnly}${filterString?.length ? ` && ${filterString}` : ''}`,
        max_facet_values: 50,
        page,
        per_page: page === 1 ? 47 : 48,
        q: query?.length ? query : '*',
        query_by: queryFields,
        typo_tokens_threshold: exactMatch ? 0 : 100
      }

      const results: any = await tsClient()
        .collections(import.meta.env.VITE_TYPESENSE_BASE_MODELS)
        .documents()
        .search(searchParameters)

      const facets: any = await tsClient()
        .collections(import.meta.env.VITE_TYPESENSE_BASE_MODELS)
        .documents()
        .search({
          facet_by: facetKeysBaseModel,
          filter_by: activeOnly,
          max_facet_values: 100,
          per_page: 0,
          q: query?.length ? query : '*',
          query_by: queryFields,
          typo_tokens_threshold: exactMatch ? 0 : 100
        })

      return {
        success: true,
        body: {
          results,
          facets
        }
      }
    }
    catch (error: any) {
      handleError(error)
      return {
        success: false
      }
    }
  }
}

export default BaseModelsService
